enum Urls {
  GetList = '/api/v1/getaddrs',
  GetExchangeList = '/api/v1/getexchangeinfos',
  AddExchange = '/api/v1/saveexchangeinfo',
  Credential = '/api/v1/createcredential',
  GetScoreQr = '/scan/apply-oscore',
  GetCommonScanResult = '/scan/result',
  GetWalletAsset = '/api/v1/wallet/info',
  GetCyanoScore = '/api/v1/getOscore',
  GetQueryScore = '/scan/query-oscore',
  SubmitPublishApi = '/scan/publish-algorithm',
}

export default Urls;
